module.exports = __webpack_public_path__ + "images/loginback_3.jpg";